module KendoWidgets
{
	//#region Event
	export class GridRebindEvent
	{
		sender: KendoWidgets.Grid;
	}

	export class GridAddEvent
	{
		sender: KendoWidgets.Button;
		preventDefault: Function;
	}

	export class GridDeleteEvent
	{
		sender: KendoWidgets.Button;
		preventDefault: Function;
	}

	export class ToolbarClickEvent
	{
		sender: KendoWidgets.Button;
		preventDefault: Function;
		item: ToolbarItem;
	}

	export class GridCustomEvent
	{
		sender: KendoWidgets.Button;
		commandName: string;
		preventDefault: Function;
	}

	export class GridRowDataBoundEvent
	{
		sender: KendoWidgets.Grid;
		preventDefault: Function;
		uid: string;
		row: GridRow;
		cells: GridCell[];

		public get item()
		{
			return this.sender.getItemByUid(this.uid);
		}
	}
	//#endregion

	export class GridOptions implements kendo.ui.GridOptions
	{
		//#region Properties
		dataSourceFieldId?: string;
		allowCopy?: boolean | kendo.ui.GridAllowCopy;
		autoBind?: boolean;
		columns?: kendo.ui.GridColumn[];
		advancedColumns?: Column[];
		advancedToolbar?: ToolbarItem[];
		columnMenu?: boolean | kendo.ui.GridColumnMenu;
		dataSource?: any | any | kendo.data.DataSource;
		editable?: boolean | "inline" | "incell" | "popup" | kendo.ui.GridEditable;
		excel?: kendo.ui.GridExcel;
		excelFileName?: string;
		filterable?: boolean | kendo.ui.GridFilterable;
		groupable?: boolean | kendo.ui.GridGroupable;
		groupEmptyMessage?: string;
		height?: number | string;
		width?: number | string;
		messages?: kendo.ui.GridMessages;
		mobile?: boolean | string;
		navigatable?: boolean;
		noRecords?: boolean | kendo.ui.GridNoRecords;
		pageable?: boolean | kendo.ui.GridPageable;
		pageSize?: number;
		pdf?: kendo.ui.GridPdf;
		persistSelection?: boolean;
		reorderable?: boolean;
		resizable?: boolean;
		rowTemplate?: string | Function;
		scrollable?: boolean | kendo.ui.GridScrollable;
		selectable?: boolean | string;
		sortable?: boolean | kendo.ui.GridSortable;
		toolbar?: string | Function | (string | kendo.ui.GridToolbarItem)[];
		defaultGroups?: string[];
		//#endregion

		//#region Callbacks toolbar
		add?(e: KendoWidgets.GridAddEvent): void;
		delete?(e: KendoWidgets.GridDeleteEvent): void;
		cancel?(e: kendo.ui.GridCancelEvent): void;
		excelExport?(e: kendo.ui.GridExcelExportEvent): void;
		save?(e: kendo.ui.GridSaveEvent): void;
		saveChanges?(e: kendo.ui.GridSaveChangesEvent): void;
		saveChangesRequest?: KendoWidgets.KendoGridSaveRequest;
		customToolbarClick?(e: KendoWidgets.GridCustomEvent): void;
		//#endregion

		//#region Callbacks
		beforeEdit?(e: kendo.ui.GridBeforeEditEvent): void;
		cellClose?(e: kendo.ui.GridCellCloseEvent): void;
		change?(e: kendo.ui.GridChangeEvent): void;
		columnHide?(e: kendo.ui.GridColumnHideEvent): void;
		columnLock?(e: kendo.ui.GridColumnLockEvent): void;
		columnMenuInit?(e: kendo.ui.GridColumnMenuInitEvent): void;
		columnMenuOpen?(e: kendo.ui.GridColumnMenuOpenEvent): void;
		columnReorder?(e: kendo.ui.GridColumnReorderEvent): void;
		columnResize?(e: kendo.ui.GridColumnResizeEvent): void;
		columnShow?(e: kendo.ui.GridColumnShowEvent): void;
		columnUnlock?(e: kendo.ui.GridColumnUnlockEvent): void;
		dataBinding?(e: kendo.ui.GridDataBindingEvent): void;
		dataBound?(e: kendo.ui.GridDataBoundEvent): void;
		rowDataBound?(e: KendoWidgets.GridRowDataBoundEvent): void;
		edit?(e: kendo.ui.GridEditEvent): void;
		filter?(e: kendo.ui.GridFilterEvent): void;
		filterMenuInit?(e: kendo.ui.GridFilterMenuInitEvent): void;
		filterMenuOpen?(e: kendo.ui.GridFilterMenuOpenEvent): void;
		group?(e: kendo.ui.GridGroupEvent): void;
		groupCollapse?(e: kendo.ui.GridGroupCollapseEvent): void;
		groupExpand?(e: kendo.ui.GridGroupExpandEvent): void;
		navigate?(e: kendo.ui.GridNavigateEvent): void;
		page?(e: kendo.ui.GridPageEvent): void;
		pdfExport?(e: kendo.ui.GridPdfExportEvent): void;
		remove?(e: kendo.ui.GridRemoveEvent): void;
		sort?(e: kendo.ui.GridSortEvent): void;
		advancedDataSource?(e: KendoWidgets.GridRebindEvent): void;
		//#endregion
	}

	export class Grid extends kendo.ui.Grid implements KendoWidget
	{
		public controlType(): ControlTypeEnum { return ControlTypeEnum.Grid; }
		private _filterFunction: number | undefined;
		private _currentUnchangedData: any[];

		constructor(element: Element, options?: KendoWidgets.GridOptions)
		{
			if (options == null)
				options = new KendoWidgets.GridOptions();

			//#region Default options
			if (options.navigatable == null) options.navigatable = true;
			if (options.groupEmptyMessage != null) options.groupable = {
				messages: { empty: options.groupEmptyMessage }
			};

			//#region Page size
			let pageSize = 300;
			if (options.pageable == null)
			{
				if (options.pageSize != null)
					pageSize = options.pageSize;

				options.pageable = { pageSize: pageSize, info: false, numeric: false, input: false, previousNext: false };
			}
			else
			{
				if (options.pageSize != null)
					options.pageable = { pageSize: options.pageSize, info: false, numeric: false, input: false, previousNext: false };
			}
			//#endregion

			if (options.sortable == null) options.sortable = true;
			if (options.resizable == null) options.resizable = true;
			if (options.sortable != false) options.columnMenu = { sortable: true };
			if (options.reorderable == null) options.reorderable = true;
			if (options.filterable == null || options.filterable == true) options.filterable = { mode: "menu,row" };
			if (options.editable == null) options.editable = true;
			if (options.excelFileName == null) options.excelFileName = "Esportazione_Griglia.xlsx";
			if (options.dataSourceFieldId == null) options.dataSourceFieldId = "Id";
			if (options.autoBind == null) options.autoBind = false;
			options.scrollable = { virtual: true };

			if (options.height == null) options.height = "Calc(100% - " + ($(element).offset().top) + "px)";

			options.excel = {
				fileName: options.excelFileName,
				filterable: true,
				allPages: true
			};
			//#endregion

			//#region Advanced toolbar
			if (options.advancedToolbar != null)
			{
				let toolbarItems: kendo.ui.GridToolbarItem[] = [];
				for (let toolbarItem of options.advancedToolbar)
				{
					let text = "";
					let name: string = toolbarItem.type;
					switch (toolbarItem.type)
					{
						case ToolbarItemType.Add: text = ((toolbarItem.text == null) ? "Aggiungi" : toolbarItem.text); break;
						case ToolbarItemType.Cancel: text = ((toolbarItem.text == null) ? "Annulla" : toolbarItem.text); break;
						case ToolbarItemType.Delete: text = ((toolbarItem.text == null) ? "Elimina" : toolbarItem.text); break;
						case ToolbarItemType.Excel: text = ((toolbarItem.text == null) ? "Excel" : toolbarItem.text); break;
						case ToolbarItemType.Save: text = ((toolbarItem.text == null) ? "Salva" : toolbarItem.text); break;
						case ToolbarItemType.Separator: text = " "; break;
						case ToolbarItemType.Custom:
							{
								name = (toolbarItem.name != null) ? toolbarItem.name : toolbarItem.text!.replace(" ", "").toLowerCase();
								text = toolbarItem.text!;
							}
							break;
					}

					let kendoToolbarItem: kendo.ui.GridToolbarItem =
					{
						name: name,
						text: text,
						iconClass: (toolbarItem.iconClass != null) ? "k-icon k-i-" + toolbarItem.iconClass : undefined
					};
					toolbarItems.push(kendoToolbarItem);
				}
				options.toolbar = toolbarItems;
			}
			//#endregion

			//#region Advanced columns
			let checkBoxes: Map<string, string> = new Map<string, string>();
			let buttons: Map<string, Column> = new Map<string, Column>()
			let labels: Map<string, Column> = new Map<string, Column>();
			if (options.advancedColumns != null)
			{
				//#region Custom filters
				let noServerFilter: kendo.ui.GridColumnFilterableCell =
				{
					showOperators: false,
					operator: "contains",
					suggestionOperator: "contains",
					template: function (e: any)
					{
						e.element.kendoAutoComplete({
							serverFiltering: false,
							valuePrimitive: true,
							noDataTemplate: ''
						});
					}
				}

				let booleanFilter: kendo.ui.GridColumnFilterableCell =
				{
					template: function (e: any)
					{
						if (e.element[0] != null)
							e.element[0].style.cssText = "display: none !important";
					}
				}
				//#endregion

				//#region Columns
				let kendoColumns: kendo.ui.GridColumn[] = [];

				if (options.advancedColumns.map(k => k.type).includes(ColumnTypeEnum.Selection))
				{
					let kendoColumn: kendo.ui.GridColumn =
					{
						selectable: true,
						width: 50
					};
					kendoColumns.push(kendoColumn);
				}

				for (let column of options.advancedColumns)
				{
					if (column.type == ColumnTypeEnum.Selection)
						continue;

					let filterType: kendo.ui.GridColumnFilterableCell | undefined = noServerFilter;
					let css = "";
					let columnAggregates: string[] = [];
					let hidden = column.hidden;
					let footerTemplate: string = "";
					let format = "";
					let template: Function | string | undefined;
					let editable: Function | undefined;
					let editor: any
					let fakeTemplate: boolean = false;

					//#region Type
					switch (column.type)
					{
						case ColumnTypeEnum.String:
							filterType = noServerFilter;
							css = "text-align: left;";
							break;
						case ColumnTypeEnum.Checkbox:
							let checkboxId = "#= uid #" + "grd_chk" + column.field;
							let checkboxClassName = "chk_" + column.field;
							checkBoxes.set(checkboxClassName, column.field!);

							let disabled = (options.editable == false) ? "disabled" : "";
							filterType = booleanFilter;
							css = "text-align: center;";
							template = '<input ' + disabled + ' class="k-checkbox ' + checkboxClassName + '" id="' + checkboxId + '" type="checkbox" #= ' + column.field + ' ? \'checked="checked"\': "" # ><label class="k-checkbox-label k-no-text" for="' + checkboxId + '"></label>';
							editable = () => { return false; };
							break;
						case ColumnTypeEnum.Number:
							{
								filterType = noServerFilter;
								css = "text-align: right;";

								let decimalDigits = (column.decimalDigits != null) ? column.decimalDigits : 0;
								template = '#=kendo.format("{0:n' + decimalDigits + '}", ' + column.field + ')#';

								//#region Footer template
								if (column.aggregateMode != false && column.aggregateMode != null)
								{
									if (column.aggregateMode == true)
									{
										footerTemplate = "#: kendo.toString(sum, 'n" + decimalDigits + "')#";
										columnAggregates = [AggregateMode.Sum];
									}
									else
									{
										footerTemplate = "#: kendo.toString(" + column.aggregateMode + ", 'n" + decimalDigits + "')#";
										columnAggregates = [column.aggregateMode];
									}
								}
								//#endregion

								//#region Format
								format = "{0:n" + decimalDigits + "}";
								//#endregion
							}
							break;
						case ColumnTypeEnum.Percentage:
							{
								filterType = noServerFilter;
								css = "text-align: right;";

								let decimalDigits = (column.decimalDigits != null) ? column.decimalDigits : 2;
								template = '#=kendo.format("{0:p' + decimalDigits + '}", ' + column.field + '/100)#';

								//#region Footer template
								if (column.aggregateMode != false && column.aggregateMode != null)
								{
									if (column.aggregateMode == true)
									{
										footerTemplate = "#: kendo.toString(average/100, 'p" + decimalDigits + "')#";
										columnAggregates = [AggregateMode.Average];
									}
									else
									{
										footerTemplate = "#: kendo.toString(" + column.aggregateMode + "/100, 'p" + decimalDigits + "')#";
										columnAggregates = [column.aggregateMode];
									}
								}
								//#endregion

								//#region Format
								format = "{0:p" + decimalDigits + "}";
								//#endregion							}
							break;
						case ColumnTypeEnum.Custom:
							filterType = undefined;
							template = column.template;
							fakeTemplate = true;
							break;
						case ColumnTypeEnum.Button:
							filterType = noServerFilter;
							css = "text-align: center;";
							fakeTemplate = true;
							editable = () => { return false; };

							if (column.buttonSettings == null)
							{
								column.buttonSettings = new GridButtonSettings();
								column.buttonSettings.value = "";
							}

							let buttonId = "#= uid #" + "grd_btn" + column.buttonSettings.value;
							let buttonClassName = "btn_" + column.buttonSettings.value;
							buttons.set(buttonClassName, column);

							let customCss = "";

							let spanIcon = "";
							let iconClass = "";
							let imageUrl = "";
							let tooltip = "";
							if (column.buttonSettings != null)
							{
								//#region custom CSS
								if (column.buttonSettings.css != null)
									customCss = column.buttonSettings.css;
								//#endregion

								//#region Icon
								if (column.buttonSettings.iconClass != null)
									iconClass = column.buttonSettings.iconClass;
								//#endregion

								//#region Image url
								if (column.buttonSettings.imageUrl != null)
									imageUrl = column.buttonSettings.imageUrl;
								//#endregion

								//#region Tooltip
								if (column.buttonSettings.tooltip != null)
									tooltip = column.buttonSettings.tooltip;
								//#endregion

								if (iconClass.length > 0)
									spanIcon = "<span style='margin-right: 5px' class='k-icon k-i-" + iconClass + "'></span> ";
								else if (imageUrl.length > 0)
									imageUrl = "<img style='margin-right: 5px' src='" + imageUrl + "' />";
							}
							template = "<button title='" + tooltip + "' style='" + customCss + "' class='k-button k-grid-button " + buttonClassName + "' id='" + buttonId + "'>" + spanIcon + imageUrl + column.buttonSettings.text + "</button>";
							break;
						case ColumnTypeEnum.Label:
							filterType = noServerFilter;
							css = "text-align: center;";
							fakeTemplate = true;
							editable = () => { return false; };

							if (column.labelSettings == null)
							{
								column.labelSettings = new GridLabelSettings();
								column.labelSettings.text = "";
								column.labelSettings.value = "";
							}

							let labelId = "#= uid #" + "grd_lbl" + column.labelSettings.value;
							let labelClassName = "lbl_" + column.labelSettings.value;
							labels.set(labelClassName, column);

							if (column.labelSettings != null)
							{
								//#region custom CSS
								let customCss = "cursor: pointer;";
								if (column.labelSettings.css != null)
									customCss = column.labelSettings.css;

								//#endregion

								//#region Underline mode
								let textDecoration = "none";
								let underlineOnFocus = "";
								if (column.labelSettings.underlineMode != null)
								{
									switch (column.labelSettings.underlineMode)
									{
										case GridLabelUnderlineMode.Always: textDecoration = "underline"; break;
										case GridLabelUnderlineMode.None: textDecoration = "none"; break;
										case GridLabelUnderlineMode.OnFocus: underlineOnFocus = "k-grid-labelhover"; break;
									}
								}
								//#endregion

								//#region Bold
								let fontWeight = "500";
								if (column.labelSettings.bold == false)
									fontWeight = "normal";
								//#endregion

								template = "<label style='font-weight:" + fontWeight + "; text-decoration: " + textDecoration + ";" + customCss + "' class='" + underlineOnFocus + " k-grid-label " + labelClassName + "' id='" + labelId + "'>" + column.labelSettings.text + "</label>";
							}
							break;
						case ColumnTypeEnum.Currency:
							{
								filterType = noServerFilter;
								css = "text-align: right;";

								let decimalDigits = (column.decimalDigits != null) ? column.decimalDigits : 2;
								template = '#=kendo.format("{0:c' + decimalDigits + '}", ' + column.field + ')#';

								//#region Footer template
								if (column.aggregateMode != false && column.aggregateMode != null)
								{
									if (column.aggregateMode == true)
									{
										footerTemplate = "#: kendo.toString(sum, 'c" + decimalDigits + "')#";
										columnAggregates = [AggregateMode.Sum];
									}
									else
									{
										footerTemplate = "#: kendo.toString(" + column.aggregateMode + ", 'c" + decimalDigits + "')#";
										columnAggregates = [column.aggregateMode];
									}
								}
								//#endregion

								//#region Format
								format = "{0:c" + decimalDigits + "}";
								//#endregion
							}
							break;
						case ColumnTypeEnum.Date:
							filterType = noServerFilter;
							css = "text-align: center;";
							template = "#= (" + column.field + " == null) ? ' ' : kendo.toString(kendo.parseDate(" + column.field + "), 'dd/MM/yyyy') #";
							break;
						case ColumnTypeEnum.Time:
							filterType = noServerFilter;
							css = "text-align: center;";
							template = "#= (" + column.field + " == null) ? ' ' : kendo.toString(kendo.parseDate(" + column.field + "), 't') #";
							break;
						case ColumnTypeEnum.DropdownList:
							filterType = noServerFilter;
							template = "#= " + column.field + ".text #";

							editor = (container: JQuery, options: kendo.ui.GridColumnEditorOptions) =>
							{
								let dropDownList = <KendoWidgets.DropDownList>$("<input name='" + options.field + "' />").appendTo(container).kendoDropDownList({
									autoWidth: true,
									width: "100%"
								}).data("kendoDropDownList");

								if (column.dataItems != null)
									dropDownList.setItems(column.dataItems);
								else
									throw new Error("Property 'dataItems' of column '" + column.field + "' is null; please, consider to fill it with an array of dropDownListItem[]");

								dropDownList.value((options.model as any)[column.field!].value);
							};
							break;
						case ColumnTypeEnum.ComboBox:
							filterType = noServerFilter;
							template = "#= " + column.field + ".text #";

							editor = (container: JQuery, options: kendo.ui.GridColumnEditorOptions) =>
							{
								let comboBox = <KendoWidgets.ComboBox>$("<input name='" + options.field + "' />").appendTo(container).kendoComboBox({
									autoWidth: true,
									width: "100%"
								}).data("kendoComboBox");

								if (column.dataItems != null)
									comboBox.setItems(column.dataItems);
								else
									throw new Error("Property 'dataItems' of column '" + column.field + "' is null; please, consider to fill it with an array of comboBoxItem[]");

								comboBox.value((options.model as any)[column.field!].value);
							};
							break;
						case ColumnTypeEnum.DropDownTree:
							filterType = noServerFilter;
							template = "#= " + column.field + ".text #";

							editor = (container: JQuery, options: kendo.ui.GridColumnEditorOptions) =>
							{
								let dropDownTree = <KendoWidgets.DropDownTree>$("<input name='" + options.field + "' />").appendTo(container).kendoDropDownTree({
									autoWidth: true,
									checkboxes: true,
									width: "100%",
									change: (e) =>
									{
										(options.model as any)[column.field!] = { text: dropDownTree.getCheckedText().toString(), values: dropDownTree.getCheckedValues() };
									}
								}).data("kendoDropDownTree");

								if (column.dataItems != null)
									dropDownTree.setItems(column.dataItems);
								else
									throw new Error("Property 'dataItems' of column '" + column.field + "' is null; please, consider to fill it with an array of dropDownTreeItem[]");

								window.setTimeout(() =>
								{
									dropDownTree.setValues((options.model as any)[column.field!].values, false);
								});
							};
							break;
						default:
							filterType = noServerFilter;
							css = "text-align: left;";
							hidden = false;
							footerTemplate = "";
							columnAggregates = [];
							format = "";
							template = undefined;
							break;
					}
					//#endregion

					if (column.css != null)
						css = column.css;

					if (column.template != null)
						template = column.template;

					let kendoColumn: any =
					{
						field: column.field,
						title: column.title,
						width: column.width,
						template: template,
						type: column.type,
						groupable: column.groupable,
						attributes: { style: css },
						editable: editable,
						editor: editor,
						filterable: (options.filterable == false) ? undefined : { cell: filterType },
						hidden: hidden,
						aggregates: columnAggregates,
						footerTemplate: footerTemplate,
						format: format,
						footerAttributes: { class: "table-footer-cell", style: css },
						fakeTemplate: fakeTemplate
					};
					kendoColumns.push(kendoColumn);
				}
				options.columns = kendoColumns;
				//#endregion

				//#region Datasource
				options.dataSource = {};
				options.dataSource.schema = {};
				options.dataSource.schema.model = {};
				options.dataSource.schema.model.fields = {};
				for (let column of options.advancedColumns)
				{
					if (column.field == null || column.field.length == 0)
						continue;

					let columnType = new ColumnType();
					columnType.type = column.type;

					let defaultValue: any | undefined = undefined;
					switch (column.type)
					{
						case ColumnTypeEnum.DropdownList: defaultValue = { value: "0", text: "" }; break;
						case ColumnTypeEnum.ComboBox: defaultValue = { value: "0", text: "" }; break;
						case ColumnTypeEnum.DropDownTree: defaultValue = { value: "0", text: "" }; break;
					}

					let dataSourceField: DataSourceField = { type: columnType.value, defaultValue: defaultValue };
					options.dataSource.schema.model.fields[column.field] = dataSourceField;
				}
				options.dataSource.schema.model.fields[options.dataSourceFieldId] = { type: ColumnTypeEnum.Number };
				//#endregion

				//#region Default groups
				if (options.defaultGroups != null)
				{
					options.dataSource.group = {};

					let groups = [];
					for (let defaultGroup of options.defaultGroups)
					{
						let group: any = {};
						group.field = defaultGroup;
						groups.push(group);
					}
					options.dataSource.group = groups;
				}
				//#endregion

				//#region Aggregate fields
				let aggregateFields: AggregateField[] | undefined = undefined;
				for (let column of options.advancedColumns)
				{
					if (column.type != ColumnTypeEnum.Number && column.type != ColumnTypeEnum.Currency && column.type != ColumnTypeEnum.Percentage)
						continue;

					if (column.aggregateMode != false && column.aggregateMode != null)
					{
						if (aggregateFields == undefined)
							aggregateFields = [];

						let aggregate = AggregateMode.Sum;
						switch (column.type)
						{
							case ColumnTypeEnum.Number:
							case ColumnTypeEnum.Currency:
								if (column.aggregateMode == true)
									aggregate = AggregateMode.Sum;
								else
									aggregate = column.aggregateMode;
								break;
							case ColumnTypeEnum.Percentage:
								if (column.aggregateMode == true)
									aggregate = AggregateMode.Average;
								else
									aggregate = column.aggregateMode;
								break;
						}

						let aggregateField: AggregateField =
						{
							field: column.field,
							aggregate: aggregate
						};
						aggregateFields.push(aggregateField);
					}
				}
				options.dataSource.aggregate = aggregateFields;
				//#endregion
			}
			//#endregion

			//#region Width
			if (options.width != null)
				$(element).width(options.width);
			//#endregion

			//#region Excel
			let excelExportUserOverride = options.excelExport;
			options.excelExport = (e: kendo.ui.GridExcelExportEvent) =>
			{
				e.preventDefault();
				that.showLoading();

				let headerRow: GridRow = new GridRow();
				let contentRows: GridRow[] = [];
				let footerRow: GridRow = new GridRow();

				// Columns
				let columns = e.sender.columns.filter(k => (k.hidden == undefined || k.hidden == false) && !(k as any).fakeTemplate);

				// Workbook
				let workbook = e.workbook;
				if (workbook != null)
				{
					// Sheets
					for (let sheet of workbook.sheets)
					{
						//#region Rows
						let rows = sheet.rows;
						if (rows != null)
						{
							let contentIndex = 0;
							for (let row of rows)
							{
								let isHeader = ((row as any).type == "header");
								let isContent = ((row as any).type == "data");
								let isFooter = ((row as any).type == "footer");
								contentRows[contentIndex] = new GridRow();

								//#region Cells
								let cells = row.cells;
								if (cells != null)
								{
									let index = 0;
									for (let cell of cells)
									{
										let gridCell = new GridCell();

										// Column
										let column = columns[index];
										if (column.selectable != null && column.selectable == true)
										{
											index++;
											column = columns[index];
										}
										index++;

										// Create dataItem
										let dataItem: any = {};
										dataItem[column.field!] = cell.value;

										// Manage template
										if (column.template != null && !isFooter && !(column as any).fakeTemplate && !isHeader)
										{
											if (typeof (cell.value) == "boolean")
												cell.value = (cell.value) ? "Sì" : "No";
											else
											{
												let template = kendo.template(column.template as string);
												if (template != null)
													cell.value = template(dataItem);
											}
										}

										// Create cell
										gridCell.text = $("<span>" + (cell.value as string) + "</span>").text();
										gridCell.field = column.field!;
										gridCell.type = (column as any).type;

										// Add cells to row
										if (isHeader) headerRow.cells.push(gridCell);
										else if (isContent) contentRows[contentIndex].cells.push(gridCell);
										else if (isFooter) footerRow.cells.push(gridCell);
									}
								}
								//#endregion

								contentIndex++;
							}
						}
						//#endregion
					}
				}

				//#region Generate Excel
				let generateExcelRequest = new GenerateExcelRequest();
				generateExcelRequest.HeaderRow = headerRow;
				generateExcelRequest.ContentRows = contentRows;
				generateExcelRequest.FooterRow = footerRow;
				generateExcelRequest.ExcelFileName = options!.excelFileName!;
				generateExcelRequest.AuthKey = "A98614F5DD19FEEECB3E4D5DBC473";
				let jsonString = JSON.stringify(generateExcelRequest);

				$.ajax({
					type: "POST",
					contentType: "application/json",
					data: jsonString,
					method: "POST",
					processData: false,
					dataType: "json",
					url: "/api/KendoGridGenerateExcelWebApi/GenerateExcel",
					success: function (response: GenerateExcelResponse, textStatus: string, jqXHR: JQueryXHR)
					{
						that.hideLoading();

						if (response.DownloadUrl != null && response.DownloadUrl.length > 0)
							location.replace(response.DownloadUrl);
					},
					error: function (response: JQueryXHR, textStatus: string, errorThrown: string)
					{
						that.hideLoading();
						kendo.alert("Errore nell'esportazione Excel");
					}
				});
				//#endregion

				if (excelExportUserOverride != null)
					excelExportUserOverride(e);
			}
			//#endregion

			//#region Row data bound
			let dataBoundUserOverride = options.dataBound;
			options.dataBound = (e: kendo.ui.GridDataBoundEvent) =>
			{
				//#region Totals
				if (options!.advancedToolbar != null)
				{
					var filters = e.sender.dataSource.filter();
					var allData = e.sender.dataSource.data();
					var query = new kendo.data.Query(allData as any);
					var data = query.filter(filters).data;

					$("#kendoGridTotalsLabel" + element.id).remove();
					let label = document.createElement("label");
					label.id = "kendoGridTotalsLabel" + element.id;
					label.textContent = data.length + " elementi";
					label.classList.add("kendoGridTotalsLabel");
					element.appendChild(label);
				}
				//#endregion

				if (options!.rowDataBound != null)
				{
					for (let tr of e.sender.element[0].getElementsByTagName("tr") as any as HTMLTableRowElement[])
					{
						let uid = tr.getAttribute("data-uid");
						if (uid == null)
							continue;

						let event = new KendoWidgets.GridRowDataBoundEvent();
						event.sender = (e.sender as KendoWidgets.Grid);
						event.uid = uid;

						//#region Row
						let row = new GridRow();
						row.element = tr;

						//#region Cells
						let gridCells: GridCell[] = [];
						$(tr).children().each((index, td) =>
						{
							let cell = new GridCell();
							cell.element = td as HTMLTableDataCellElement;
							cell.field = (options!.advancedColumns != null && options!.advancedColumns[index] != null) ? options!.advancedColumns[index].field : "";
							cell.type = (options!.advancedColumns != null && options!.advancedColumns[index] != null) ? options!.advancedColumns[index].type : undefined;
							cell.text = (td as HTMLTableDataCellElement).innerText;

							gridCells.push(cell);
						});
						row.cells = gridCells;
						//#endregion

						event.row = row;
						//#endregion

						options!.rowDataBound(event);
					}
				}

				if (dataBoundUserOverride != null)
					dataBoundUserOverride(e);
			};
			//#endregion

			//#region Edit
			let saveUserOverride = options.save;
			options.save = (e: kendo.ui.GridSaveEvent) =>
			{
				$(".k-grid-save-changes").addClass("edited-highlight");
				$(".k-grid-cancelChanges").data("kendoButton").enable(true);
				$(".k-grid-save-changes").data("kendoButton").enable(true);

				if (saveUserOverride != null)
					saveUserOverride(e);
			}
			//#endregion

			super(element, options);
			let that = this;

			//#region Checkboxes management
			checkBoxes.forEach((field: string, className: string) =>
			{
				this.tbody.on("change", "." + className, (e) =>
				{
					let row = $(e.target).closest("tr");
					let item = this.dataItem(row);
					item.set(field, $(e.target).is(":checked") ? 1 : 0);

					let event: any = {};
					if (that.options.save != null)
						that.options.save(event);
				});
			});
			//#endregion

			//#region Buttons management
			buttons.forEach((column: Column, className: string) =>
			{
				this.tbody.on("click", "." + className, (e) =>
				{
					if (column.buttonSettings != null)
					{
						let row = $(e.target).closest("tr");
						let item = this.dataItem(row);

						if (column.buttonSettings.click != null)
							column.buttonSettings.click(item);
					}
				});
			});
			//#endregion

			//#region Labels management
			labels.forEach((column: Column, className: string) =>
			{
				this.tbody.on("click", "." + className, (e) =>
				{
					if (column.labelSettings != null)
					{
						let row = $(e.target).closest("tr");
						let item = this.dataItem(row);

						if (column.labelSettings.click != null)
							column.labelSettings.click(item);
					}
				});
			});
			//#endregion
			//#region Filter 
			if (options.filterable != false)
			{
				that.element.find(".k-filtercell").keyup(function (e: JQueryKeyEventObject)
				{
					clearTimeout(that._filterFunction);
					let stringSearched = (e.target as HTMLInputElement).value;

					if (stringSearched.length == 0)
						that.clearAllFilters();
					else
					{
						//that.setOptions({ pageable: { pageSize: 10, info: false, numeric: false, input: false, previousNext: false } });
						that._filterFunction = setTimeout(() =>
						{
							let dataField = e.currentTarget.getAttribute("data-field");
							if (dataField != null)
								that.dataSource.filter({ field: dataField, operator: "contains", value: stringSearched });
						}, 500);
					}
				});
			}
			//#endregion

			//#region Toolbar buttons
			if (options.advancedToolbar != null)
			{
				for (let toolbarItem of options.advancedToolbar)
				{
					switch (toolbarItem.type)
					{
						case ToolbarItemType.Save:
							$(".k-grid-save-changes").kendoButton(
								{
									enable: false,
									click: (e) =>
									{
										let items = this.getAllItems() as any as any[];

										if (options!.saveChangesRequest != null)
										{
											let json: any = {};
											json.AuthKey = options!.saveChangesRequest.authKey;
											json.method = options!.saveChangesRequest.method;
											json[options!.saveChangesRequest.itemsName] = items;
											let jsonS = JSON.stringify(json);

											that.showLoading();
											$.ajax({
												type: "POST",
												contentType: "application/json",
												data: jsonS,
												method: "POST",
												processData: false,
												dataType: "json",
												url: options!.saveChangesRequest.method,
												success: function (response: any, textStatus: string, jqXHR: JQueryXHR)
												{
													that.hideLoading();
													that.showNotification("Salvataggio effettuato correttamente.");

													$(".k-grid-save-changes").removeClass("edited-highlight");
													$(".k-grid-cancelChanges").data("kendoButton").enable(false);
													$(".k-grid-save-changes").data("kendoButton").enable(false);

													that._currentUnchangedData = [];
													for (let item of that.getAllItems() as any as any[])
													{
														let currentItem = jQuery.extend(true, {}, item);
														that._currentUnchangedData.push(currentItem);
													}

													//#region Event callback
													if (toolbarItem.click != null)
													{
														let toolbarClickEvent = new ToolbarClickEvent();
														toolbarClickEvent.sender = e.sender as KendoWidgets.Button;
														toolbarClickEvent.preventDefault = e.preventDefault;
														toolbarClickEvent.item = toolbarItem;
														toolbarItem.click(toolbarClickEvent);
													}
													//#endregion
												},
												error: function (response: JQueryXHR, textStatus: string, errorThrown: string)
												{
													that.hideLoading();
													kendo.alert("Errore nel salvataggio");
												}
											});
										}
										else
										{
											$(".k-grid-save-changes").removeClass("edited-highlight");
											$(".k-grid-cancelChanges").data("kendoButton").enable(false);
											$(".k-grid-save-changes").data("kendoButton").enable(false);

											that._currentUnchangedData = [];
											for (let item of that.getAllItems() as any as any[])
											{
												let currentItem = jQuery.extend(true, {}, item);
												that._currentUnchangedData.push(currentItem);
											}

											//#region Event callback
											if (toolbarItem.click != null)
											{
												let toolbarClickEvent = new ToolbarClickEvent();
												toolbarClickEvent.sender = e.sender as KendoWidgets.Button;
												toolbarClickEvent.preventDefault = e.preventDefault;
												toolbarClickEvent.item = toolbarItem;
												toolbarItem.click(toolbarClickEvent);
											}
											//#endregion
										}
									}
								});
							break;
						case ToolbarItemType.Add:
							$(".k-grid-add").kendoButton(
								{
									click: (e) =>
									{
										let event = new GridAddEvent();
										event.sender = e.sender as KendoWidgets.Button;
										event.preventDefault = e.preventDefault;

										if (toolbarItem.confirmationMessage != null && toolbarItem.confirmationMessage.length > 0)
										{
											kendo.confirm(toolbarItem.confirmationMessage).then(() =>
											{
												$(".k-grid-save-changes").addClass("edited-highlight");
												$(".k-grid-cancelChanges").data("kendoButton").enable(true);
												$(".k-grid-save-changes").data("kendoButton").enable(true);

												//#region Event callback
												if (toolbarItem.click != null)
												{
													let toolbarClickEvent = new ToolbarClickEvent();
													toolbarClickEvent.sender = e.sender as KendoWidgets.Button;
													toolbarClickEvent.preventDefault = e.preventDefault;
													toolbarClickEvent.item = toolbarItem;
													toolbarItem.click(toolbarClickEvent);
												}
												//#endregion

												if ((that.options as KendoWidgets.GridOptions).add != null)
													(that.options as KendoWidgets.GridOptions).add!(event);
											});
										}
										else
										{
											$(".k-grid-save-changes").addClass("edited-highlight");
											$(".k-grid-cancelChanges").data("kendoButton").enable(true);
											$(".k-grid-save-changes").data("kendoButton").enable(true);

											//#region Event callback
											if (toolbarItem.click != null)
											{
												let toolbarClickEvent = new ToolbarClickEvent();
												toolbarClickEvent.sender = e.sender as KendoWidgets.Button;
												toolbarClickEvent.preventDefault = e.preventDefault;
												toolbarClickEvent.item = toolbarItem;
												toolbarItem.click(toolbarClickEvent);
											}
											//#endregion

											if ((that.options as KendoWidgets.GridOptions).add != null)
												(that.options as KendoWidgets.GridOptions).add!(event);
										}
									}
								});
							break;
						case ToolbarItemType.Cancel:
							$(".k-grid-cancelChanges").kendoButton(
								{
									enable: false,
									click: (e) =>
									{
										let event: any = {};
										event.sender = e.sender as KendoWidgets.Button;
										event.preventDefault = e.preventDefault;

										if (toolbarItem.confirmationMessage != null && toolbarItem.confirmationMessage.length > 0)
										{
											kendo.confirm(toolbarItem.confirmationMessage).then(() =>
											{
												$(".k-grid-save-changes").removeClass("edited-highlight");
												$(".k-grid-cancelChanges").data("kendoButton").enable(false);
												$(".k-grid-save-changes").data("kendoButton").enable(false);

												that.setItems(that._currentUnchangedData);

												//#region Event callback
												if (toolbarItem.click != null)
												{
													let toolbarClickEvent = new ToolbarClickEvent();
													toolbarClickEvent.sender = e.sender as KendoWidgets.Button;
													toolbarClickEvent.preventDefault = e.preventDefault;
													toolbarClickEvent.item = toolbarItem;
													toolbarItem.click(toolbarClickEvent);
												}
												//#endregion

												if ((that.options as KendoWidgets.GridOptions).cancel != null)
													(that.options as KendoWidgets.GridOptions).cancel!(event);
											});
										}
										else
										{
											$(".k-grid-save-changes").removeClass("edited-highlight");
											$(".k-grid-cancelChanges").data("kendoButton").enable(false);
											$(".k-grid-save-changes").data("kendoButton").enable(false);

											that.setItems(this._currentUnchangedData);

											//#region Event callback
											if (toolbarItem.click != null)
											{
												let toolbarClickEvent = new ToolbarClickEvent();
												toolbarClickEvent.sender = e.sender as KendoWidgets.Button;
												toolbarClickEvent.preventDefault = e.preventDefault;
												toolbarClickEvent.item = toolbarItem;
												toolbarItem.click(toolbarClickEvent);
											}
											//#endregion

											if ((that.options as KendoWidgets.GridOptions).cancel != null)
												(that.options as KendoWidgets.GridOptions).cancel!(event);
										}
									}
								});
							break;
						case ToolbarItemType.Excel:
							$(".k-grid-excel").kendoButton(
								{
									click: (e) =>
									{
										//#region Event callback
										if (toolbarItem.click != null)
										{
											let toolbarClickEvent = new ToolbarClickEvent();
											toolbarClickEvent.sender = e.sender as KendoWidgets.Button;
											toolbarClickEvent.preventDefault = e.preventDefault;
											toolbarClickEvent.item = toolbarItem;
											toolbarItem.click(toolbarClickEvent);
										}
										//#endregion
									}
								});
							break;
						case ToolbarItemType.Delete:
							$(".k-grid-delete").kendoButton(
								{
									click: (e) =>
									{
										let checkedItems = that.getCheckedDataItems();
										if (checkedItems.length == 0)
										{
											that.showNotification("Devi selezionare almeno una riga");
											return;
										}

										let event = new GridDeleteEvent();
										event.sender = e.sender as KendoWidgets.Button;
										event.preventDefault = e.preventDefault;

										if (toolbarItem.confirmationMessage != null && toolbarItem.confirmationMessage.length > 0)
										{
											kendo.confirm(toolbarItem.confirmationMessage).then(() =>
											{
												for (let itemsToDelete of checkedItems)
													that.dataSource.remove(itemsToDelete as any);

												let save = $(".k-grid-save-changes");
												let cancel = $(".k-grid-cancelChanges").data("kendoButton");
												let saveData = save.data("kendoButton");

												if (save != null)
													save.addClass("edited-highlight");

												if (cancel != null)
													cancel.enable(true);

												if (saveData != null)
													saveData.enable(true);

												//#region Event callback
												if (toolbarItem.click != null)
												{
													let toolbarClickEvent = new ToolbarClickEvent();
													toolbarClickEvent.sender = e.sender as KendoWidgets.Button;
													toolbarClickEvent.preventDefault = e.preventDefault;
													toolbarClickEvent.item = toolbarItem;
													toolbarItem.click(toolbarClickEvent);
												}
												//#endregion

												if ((that.options as KendoWidgets.GridOptions).delete != null)
													(that.options as KendoWidgets.GridOptions).delete!(event);
											});
										}
										else
										{
											for (let itemsToDelete of checkedItems)
												that.dataSource.remove(itemsToDelete as any);

											$(".k-grid-save-changes").addClass("edited-highlight");
											$(".k-grid-cancelChanges").data("kendoButton").enable(true);
											$(".k-grid-save-changes").data("kendoButton").enable(true);

											//#region Event callback
											if (toolbarItem.click != null)
											{
												let toolbarClickEvent = new ToolbarClickEvent();
												toolbarClickEvent.sender = e.sender as KendoWidgets.Button;
												toolbarClickEvent.preventDefault = e.preventDefault;
												toolbarClickEvent.item = toolbarItem;
												toolbarItem.click(toolbarClickEvent);
											}
											//#endregion

											if ((that.options as KendoWidgets.GridOptions).delete != null)
												(that.options as KendoWidgets.GridOptions).delete!(event);
										}
									}
								});
							break;
						case ToolbarItemType.Custom:
							let className = (toolbarItem.name != null) ? toolbarItem.name : toolbarItem.text!.replace(" ", "").toLowerCase();
							$(".k-grid-" + className).kendoButton(
								{
									click: (e) =>
									{
										let toolbarClickEvent = new ToolbarClickEvent();
										toolbarClickEvent.sender = e.sender as KendoWidgets.Button;
										toolbarClickEvent.preventDefault = e.preventDefault;
										toolbarClickEvent.item = toolbarItem;

										let event = new GridCustomEvent();
										event.sender = e.sender as KendoWidgets.Button;
										event.commandName = toolbarItem.text!.replace(" ", "");
										event.preventDefault = e.preventDefault;

										if (toolbarItem.confirmationMessage != null && toolbarItem.confirmationMessage.length > 0)
										{
											kendo.confirm(toolbarItem.confirmationMessage).then(() =>
											{
												//#region Event callback
												if (toolbarItem.click != null)
													toolbarItem.click(toolbarClickEvent);
												//#endregion

												if ((that.options as KendoWidgets.GridOptions).customToolbarClick != null)
													(that.options as KendoWidgets.GridOptions).customToolbarClick!(event);
											});
										}
										else
										{
											//#region Event callback
											if (toolbarItem.click != null)
												toolbarItem.click(toolbarClickEvent);
											//#endregion

											if ((that.options as KendoWidgets.GridOptions).customToolbarClick != null)
												(that.options as KendoWidgets.GridOptions).customToolbarClick!(event);
										}
									}
								});
							break;
					}
				}
			}
			//#endregion

			that.rebind();
		}

		//#region Methods
		private showNotification(message: string)
		{
			let that = this;
			let divNotificationFragment = document.createDocumentFragment();

			$("#notificationManagerDivNotification").remove();
			let divNotification = document.createElement("div");
			divNotification.id = "notificationManagerDivNotification"
			divNotification.classList.add("cssNotificationManagerDivNotification");
			divNotification.style.cssText += "background-color: #E3F1FA; border: solid 2px #51B3E1;";
			divNotificationFragment.appendChild(divNotification);
			document.getElementsByTagName("body")![0].appendChild(divNotificationFragment);

			divNotification.style.cssText += "display: flex; flex-direction: column; justify-content: center;";
			divNotification.innerHTML = DOMPurify.sanitize("<div style='max-width: 500px;'>" + message + "</div>");

			let elementHeight = divNotification.clientHeight;

			//#region Slide down from top
			let toPosition = 0;
			let fromPosition = elementHeight - (2 * elementHeight);
			let speedInMilliseconds = 5;

			let id = setInterval(SlideDownFromTop, speedInMilliseconds);

			function SlideDownFromTop()
			{
				if (fromPosition == toPosition)
					clearInterval(id);
				else
				{
					fromPosition++;
					divNotification.style.top = fromPosition + "px";
				}
			}
			//#endregion

			setTimeout(function ()
			{
				that.hideNotification();
			}, 5000);
		}

		private hideNotification()
		{
			let divNotification = document.getElementById("notificationManagerDivNotification");
			if (divNotification != null)
			{
				let elementHeight = divNotification.clientHeight;

				//#region Slide up to top
				let toPosition = elementHeight - (2 * elementHeight);
				let fromPosition = 0;
				let speedInMilliseconds = 5;

				let id = setInterval(SlideUpToTop, speedInMilliseconds);

				function SlideUpToTop()
				{
					if (fromPosition == toPosition)
					{
						clearInterval(id);
						divNotification!.style.display = "none";
					}
					else
					{
						fromPosition--;
						divNotification!.style.top = fromPosition + "px";
					}
				}
				//#endregion
			}
		}

		showLoading()
		{
			// Element
			let zIndex: number = 2500000;
			let element = $(document.body);

			// Background
			let backgroundWidth = "100%";
			let backgroundHeight = "100%";
			let backgroundPosition = $(element).offset();

			let background: HTMLDivElement = document.createElement("div");
			background.setAttribute("id", "DivBackgroundLoadingGrid");
			background.setAttribute("style", "position: absolute; left: " + backgroundPosition.left + "px; top: " + backgroundPosition.top + "px; z-index: " + zIndex.toString() + "; background-color: #FFF; opacity: 0.5; width: " + backgroundWidth + "; height: " + backgroundHeight + ";");
			$(background).appendTo(element[0]);

			// Loader
			let loaderXPosition = "Calc(50% - 50px)";
			let loaderYPosition = "Calc(50% - 50px)";
			let loaderWidth = "80px";
			let loaderHeight = "80px";

			let loader: HTMLDivElement = document.createElement("div");
			loader.setAttribute("id", "DivLoaderGrid");
			loader.setAttribute("style", "z-index: " + (zIndex + 1).toString() + "; border: 16px solid #ccc; border-radius: 50%; border-top: 16px solid #3498db; width: " + loaderWidth + "; height: " + loaderHeight + "; position: absolute; left: " + loaderXPosition + "; top: " + loaderYPosition + "; -webkit-animation: spin 2s linear infinite; animation: spin 2s linear infinite;");
			$(loader).appendTo(element[0]);
		}

		hideLoading()
		{
			let background: HTMLDivElement = document.getElementById("DivBackgroundLoadingGrid") as HTMLDivElement;
			if (background != null)
				background.parentNode!.removeChild(background);

			let loader: HTMLDivElement = document.getElementById("DivLoaderGrid") as HTMLDivElement;
			if (loader != null)
				loader.parentNode!.removeChild(loader);
		}

		getItemByUid(uid: string)
		{
			let gridItem = new GridItem();
			if (this.dataSource != null)
			{
				gridItem.dataItem = this.dataSource.getByUid(uid);
				gridItem.row = new GridRow();
				gridItem.row.element = this.element.find("tr[data-uid=" + uid + "]")[0] as HTMLTableRowElement;
				return gridItem;
			}

			return null;
		}

		getSelectedItem()
		{
			return this.getCheckedItems()[0];
		}

		getCheckedItems()
		{
			let items: GridItem[] = [];
			let that = this;
			let sel = $("input[aria-checked=true]", that.tbody).closest("tr");
			$.each(sel, function (idx, row)
			{
				if (row.classList.contains("k-state-selected"))
				{
					let item = new GridItem();
					item.dataItem = that.dataItem(row);
					item.row = new GridRow();
					item.row.element = row;
					items.push(item);
				}
			});
			return items;
		}

		getCheckedDataItems()
		{
			return this.getCheckedItems().map(k => k.dataItem);
		}

		getAllItems()
		{
			return this.dataSource.data();
		}

		setItems(items: any[])
		{
			this.dataSource.data(items);

			this._currentUnchangedData = [];
			for (let item of items)
			{
				let currentItem = jQuery.extend(true, {}, item);
				this._currentUnchangedData.push(currentItem);
			}
		}

		rebind()
		{
			let advancedDataSourceOption = (this.options as KendoWidgets.GridOptions).advancedDataSource;
			if (advancedDataSourceOption != null)
			{
				let event = new KendoWidgets.GridRebindEvent();
				event.sender = this;
				advancedDataSourceOption(event);
			}
		}

		clearAllFilters()
		{
			this.dataSource.filter({});
		}
		//#endregion
	}

	Grid.fn = Grid.prototype;
	Grid.fn.options = $.extend(true, {}, kendo.ui.Grid.fn.options);
	Grid.fn.options.name = "Grid";
	kendo.ui.plugin(Grid);

	//#region Classes and Enums
	export abstract class KendoGridSaveRequest
	{
		authKey: string;
		method: string;

		abstract get itemsName(): string;
	}

	export class GridItem
	{
		dataItem: any;
		row: GridRow;
	}

	export class GridRow
	{
		cells: GridCell[] = [];
		element: HTMLTableRowElement;
	}

	export class GridCell
	{
		field?: string;
		type?: ColumnTypeEnum;
		text?: string;
		element: HTMLTableDataCellElement;
	}

	export class ToolbarItem
	{
		type: ToolbarItemType;
		text?: string;
		iconClass?: string;
		confirmationMessage?: string;
		name?: string;
		click?: (e: ToolbarClickEvent) => void;
	}

	export enum ToolbarItemType
	{
		Add = "create",
		Delete = "destroy",
		Separator = "separator",
		Save = "save",
		Cancel = "cancelChanges",
		Excel = "excel",
		Custom = "custom"
	}

	export class GridButtonSettings
	{
		text: string = "";
		click?: (dataItem: any) => void;
		css?: string;
		value: string;
		iconClass?: string;
		imageUrl?: string;
		tooltip?: string;
	}

	export class GridLabelSettings
	{
		text: string;
		click?: (dataItem: any) => void;
		underlineMode?: GridLabelUnderlineMode;
		css?: string;
		bold?: boolean;
		value: string;
	}

	export enum GridLabelUnderlineMode
	{
		Always,
		None,
		OnFocus
	}

	export class Column
	{
		type: ColumnTypeEnum;
		groupable?: boolean;
		field?: string;
		title?: string;
		width?: string | number;
		aggregateMode?: boolean | AggregateMode;
		css?: string;
		decimalDigits?: number;
		hidden?: boolean;
		dataItems?: any[];
		buttonSettings?: KendoWidgets.GridButtonSettings;
		labelSettings?: KendoWidgets.GridLabelSettings;

		/** Caution!! Filling this field will override all default templates and default behaviors!! */
		template?: ((dataItem: any) => string) | string;
	}

	export class ColumnType
	{
		type: ColumnTypeEnum;

		get value()
		{
			switch (this.type)
			{
				case ColumnTypeEnum.String: return "string";
				case ColumnTypeEnum.Checkbox: return "boolean";
				case ColumnTypeEnum.Selection: return undefined;
				case ColumnTypeEnum.Date: return "date";
				case ColumnTypeEnum.Time: return "date";
				case ColumnTypeEnum.Number: return "number";
				case ColumnTypeEnum.Currency: return "number";
				case ColumnTypeEnum.Percentage: return "number";
				case ColumnTypeEnum.DropdownList: return undefined;
				case ColumnTypeEnum.ComboBox: return undefined;
				case ColumnTypeEnum.DropDownTree: return undefined;
				case ColumnTypeEnum.Button: return undefined;
				case ColumnTypeEnum.Label: return undefined;
				case ColumnTypeEnum.Custom: return undefined;
				default: return undefined;
			}
		}
	}

	export enum ColumnTypeEnum
	{
		String = "string",
		Checkbox = "boolean",
		Selection = "selection",
		Date = "date",
		Time = "time",
		Number = "number",
		Currency = "currency",
		Percentage = "percentage",
		DropdownList = "dropDownList",
		ComboBox = "comboBox",
		DropDownTree = "dropDownTree",
		Button = "button",
		Label = "label",
		Custom = "custom"
	}

	export enum AggregateMode
	{
		Average = "average",
		Count = "count",
		Max = "max",
		Min = "min",
		Sum = "sum"
	}

	class DataSourceField
	{
		type?: string;
		defaultValue?: any;
	}

	class AggregateField
	{
		field?: string;
		aggregate?: AggregateMode;
	}

	class GenerateExcelRequest
	{
		public HeaderRow: GridRow;
		public ContentRows: GridRow[];
		public FooterRow: GridRow;
		public ExcelFileName: string;
		public AuthKey: string;
	}

	class GenerateExcelResponse
	{
		public DownloadUrl: string;
	}
	//#endregion

	//#region Control type enum
	//#endregion
    //#region Control type enum
    export enum ControlTypeEnum {
        Button,
        Chart,
        CheckBox,
        ComboBox,
        DatePicker,
        DateTimePicker,
        DropDownList,
        DropDownTree,
        Grid,
        Label,
        NumericTextBox,
        RadioButtonList,
        Switch,
        TabStrip,
        TextBox,
        Upload,
        Window,
        Separator,
        Editor,
        ColorPicker,
        TimePicker,
        CheckBoxList,
        TreeView,
        Dialog,
        SplitButton,
        ToggleButtonList,
        PDFViewer,
        Image,
        MaskedTextBox,
        GroupBox,
        Table,
        TreeGrid,
        SearchBar,
        SlideShow,
        Calendar,
        CardList,
        Legend,
        LinearGauge,
        RadialGauge,
        ArcGauge,
        Slider,
        DynamicFieldChart,
        VrRating,
        PrintButton,
        QRCode
    }

	export interface KendoWidget
	{
        element: any;
		controlType(): ControlTypeEnum;
	}
	//#endregion
}

interface JQuery
{
	kendoGrid(options?: KendoWidgets.GridOptions): JQuery;
}